export default __webpack_public_path__ + "static/Akanke-4c57fbdf6dfe5bc9db44bf92c5d2acfa.svg";